import { render, staticRenderFns } from "./navigations.vue?vue&type=template&id=3aae1591&scoped=true&lang=pug&"
import script from "./navigations.vue?vue&type=script&lang=js&"
export * from "./navigations.vue?vue&type=script&lang=js&"
import style0 from "./navigations.vue?vue&type=style&index=0&id=3aae1591&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae1591",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
